module.exports = __webpack_public_path__ + "static/media/smartAsn-logos-BNI.5a50209a.svg";